<template>
  <div class="bm-introduction" >
    <div class="main" v-if="!teamList.length" >
      <div class="title" >没有可选择的球队导入</div>
      <p>您还可以 <router-link :to="'/create?matchId=' + matchId" >创建球队</router-link></p>
    </div>
    <div v-if="teamList.length" class="main" >
      <div>
        <div class="title">
          选择球队
          <span>{{ result.length }}<i>/{{ teamList.length }}</i></span>
        </div>
      </div>
      <van-checkbox-group v-model="result" >
        <van-cell-group class="checkbox" v-for="item in teamList" :key="item.id" >
          <van-cell>
            <div class="team" >
              <div>
                <img :src="formatterImgSrc(item.badge)" >
              </div>
              <div>
                <p>{{ item.name }}</p>
                <span>{{ item.location }}</span>
              </div>
            </div>
            <van-checkbox :name="item.id" />
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div style="width: 100%; height: 45px;" ></div>
      <div class="foot" @click="updateBMMatchTeamRelations" >
        完成
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { ImageFormat } from '@/utils/'
import { Icon, Toast } from 'vant'
import { getBMTeamListByMatchId, updateBMMatchTeamRelations, getBMMatchTeams } from '@/api/team'
Vue.use(Icon).use(Toast)
export default {
  data() {
    return {
      chinckIn: false,
      result: [],
      query: null,
      matchId: null,
      oldMatchId: null,
      teamList: [],
      passTeams: []
    }
  },
  created() {
    this.query = this.$route.query
    this.matchId = this.query.matchId
    this.oldMatchId = this.query.oldMatchId
    if (!this.matchId || !this.oldMatchId) {
      Toast.loading({
        mask: true,
        message: '参数错误',
        duration: 0
      })
      return
    }
    this.getBMTeamListByMatchId()
    // this.getBMMatchTeams()
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    }
  },
  methods: {
    getBMTeamListByMatchId() {
      getBMTeamListByMatchId({matchId: this.oldMatchId, all: 1}).then(response => {
        let data = response.data
        this.teamList = data.teams
      })
    },
    updateBMMatchTeamRelations() {
      if (!this.result.length) {
        return
      }
      let params = {
        matchId: this.matchId,
        oldMatchId: this.oldMatchId,
        teamIds: this.result.join(),
        link: 1,
        importOldMatchPlayer: 0
      }
      updateBMMatchTeamRelations(params).then(response => {
        Toast.loading({
          message: '导入球队成功',
          duration: 1000
        })
        this.$router.push({
          path: '/participate/team-list',
          query: {
            matchId: this.matchId
          }
        })
      })
    },
    getBMMatchTeams() {
      getBMMatchTeams({ matchId: this.matchId }).then(response => {
        let data = response.data
        this.passTeams = data.passTeams
        this.passTeams.forEach(item => {
          this.result.push(item.teamId)
        })
      })
    }
  }
}
</script>

<style lang="stylus">
  .bm-introduction
    background-color: white
    width 100%
    height: 100%
    position absolute
    .title
      font-size: 30px;
      font-weight: 400;
      color: rgba(0,0,0,1);
      padding: 10px 15px;
    span
      letter-spacing 2px
      text-align left
      float right
      i
        font-size: 18px
        font-style: normal
    .team
      display inline-flex
      width: calc(100% - 30px)
      div:first-child
        width 52px
        height 52px
        margin-right: 10px
        img
          width 52px
          height 52px
      div:nth-child(2)
        display flex
        flex-direction column
        justify-content: space-between;
        width: calc(100% - 112px)
        p
          margin: 0;
          font-size:14px;
          font-weight:400;
          color:rgba(0,0,0,1);
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap
        span
          font-size:12px;
          font-weight:400;
          color:rgba(129,129,129,1);
    .title+p
      font-size:16px;
      font-weight:400;
      color:rgba(0,0,0,1);
      padding: 0 15px
      margin-top 0
      a
        color: #32A377
    .team+.van-checkbox
      display inline
    .checkbox
      .van-cell
        .van-cell__value
          display flex
          align-items: center
    .van-hairline--top-bottom::after
      border-width 0
    .foot
      padding: 10px 0
      background: rgba(250,250,250,1);
      text-align center
      position fixed
      bottom: 0
      width: 100%
      font-size:20px;
      font-weight:400;
      color:rgba(50,163,119,1);
</style>



// WEBPACK FOOTER //
// src/pages/introduction/team.vue